import type {
  AssetRiskFieldValue,
  AssetRiskMutateValue,
} from "./asset-risk-field.type";
import type { AssetEntity } from "@/entities/asset";

import { ASSET_NO_RISK_VALUE } from "@/modules/asset/asset-risk";

export const getAssetRiskFieldValue = (
  asset?: AssetEntity
): AssetRiskFieldValue => {
  return asset?.risk_level ?? ASSET_NO_RISK_VALUE;
};

export const getAssetRiskMutateValue = (
  value?: AssetRiskFieldValue | AssetRiskMutateValue
): AssetRiskMutateValue => {
  return value === ASSET_NO_RISK_VALUE ? null : (value ?? null);
};
